const START_AT_VIEWPORT_FRACTION = 0.88;
const EXTRA_TRAVEL_VIEWPORT_FRACTION = 0.3;
const FINISH_EARLY_FACTOR = 1.1;

export const getLitWordCount = ({ top, height, viewportHeight, wordCount }) => {
  const progress =
    (viewportHeight * START_AT_VIEWPORT_FRACTION - top) /
    (height + viewportHeight * EXTRA_TRAVEL_VIEWPORT_FRACTION);
  const clampedProgress = Math.min(Math.max(progress, 0), 1);

  return Math.min(
    Math.round(clampedProgress * wordCount * FINISH_EARLY_FACTOR),
    wordCount
  );
};
